
import {
    defineComponent,
    onBeforeMount,
    reactive,
    toRaw
} from "vue";
import CigoAvatar from "@/components/cigo-ui/unit/form/uploader/cigo-avatar.vue";
import Edit from "@/components/cigo-admin-core/pages/template/Edit.vue";

export default defineComponent({
    name: "CigoEditUser",
    components: {
        CigoAvatar,
        Edit
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let formData = {
            id: props.layerData.recordCurr ?
                props.layerData.recordCurr.id : null,
            img: props.layerData.recordCurr ?
                props.layerData.recordCurr.img : 0,
            img_info: props.layerData.recordCurr &&
                props.layerData.recordCurr.img_info ?
                props.layerData.recordCurr.img_info : {
                    id: 0
                },
            username: props.layerData.recordCurr ?
                props.layerData.recordCurr.username : "",
            nickname: props.layerData.recordCurr ?
                props.layerData.recordCurr.nickname : "",
            password: "",
            sex: props.layerData.recordCurr ?
                props.layerData.recordCurr.sex : 0,
            phone: props.layerData.recordCurr ?
                props.layerData.recordCurr.phone : "",
            email: props.layerData.recordCurr ?
                props.layerData.recordCurr.email : ""
        };
        const formItemRules = {
            username: [{
                required: true,
                message: "请输入用户名"
            }],
            password: [{
                    required: true,
                    message: "请设置密码"
                },
                {
                    max: 20,
                    message: "密码最多20个字符"
                },
                {
                    min: 6,
                    message: "密码最少6个字符"
                }
            ],
            phone: [{
                    required: true,
                    message: "请输入手机号"
                },
                {
                    len: 11,
                    message: "手机号错误"
                }
            ],
            email: [{
                type: "email",
                message: "邮箱格式错误"
            }]
        };

        const beforeEdit = (params: any) => {
            delete params.img_info;
        };

        const updateAvatarInfo = (avatarInfo: any, formDataProxy: any) => {
            formDataProxy.img = avatarInfo.id;
            formDataProxy.img_info = avatarInfo;
        };

        return {
            formData,
            formItemRules,
            beforeEdit,
            updateAvatarInfo
        };
    }
});
